import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newBedfordConfig } from "./data";

export default function NewBedfordPage() {
  return <CityPageTemplate config={newBedfordConfig} />;
}